import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierTaskPage.taskDetails.title',
    defaultMessage: 'Title',
  },
  supplierId: {
    id: 'containers.SupplierTaskPage.taskDetails.supplierId',
    defaultMessage: 'Supplier ID',
  },
  supplier: {
    id: 'containers.SupplierTaskPage.taskDetails.supplier',
    defaultMessage: 'Supplier',
  },
  invoiceRef: {
    id: 'containers.SupplierTaskPage.taskDetails.invoiceRef',
    defaultMessage: 'Invoice Ref',
  },
  fee: {
    id: 'containers.SupplierTaskPage.taskDetails.fee',
    defaultMessage: 'Your Fee',
  },
  buyoutFee: {
    id: 'containers.SupplierTaskPage.taskDetails.buyoutFee',
    defaultMessage: 'Potential usage fee',
  },
  jobDeadline: {
    id: 'containers.SupplierTaskPage.taskDetails.jobDeadline',
    defaultMessage: 'Job Deadline',
  },
  client: {
    id: 'containers.SupplierTaskPage.taskDetails.client',
    defaultMessage: 'End Client',
  },
  period: {
    id: 'containers.SupplierTaskPage.taskDetails.period',
    defaultMessage: 'Airing time',
  },
  territoryMarket: {
    id: 'containers.SupplierTaskPage.taskDetails.territoryMarket',
    defaultMessage: 'Territory/Market',
  },
  media: {
    id: 'containers.SupplierTaskPage.taskDetails.media',
    defaultMessage: 'Media',
  },
  coordinator: {
    id: 'containers.SupplierTaskPage.taskDetails.coordinator',
    defaultMessage: 'Coordinator',
  },
  phone: {
    id: 'containers.SupplierTaskPage.taskDetails.phone',
    defaultMessage: 'Phone',
  },
  email: {
    id: 'containers.SupplierTaskPage.taskDetails.email',
    defaultMessage: 'E-mail',
  },
  taskType: {
    id: 'containers.SupplierTaskPage.taskDetails.taskType',
    defaultMessage: 'Task Type',
  },
  services: {
    id: 'containers.SupplierTaskPage.taskDetails.services',
    defaultMessage: 'Services',
  },
  products: {
    id: 'containers.SupplierTaskPage.taskDetails.products',
    defaultMessage: 'Products',
  },
  buyouts: {
    id: 'containers.SupplierTaskPage.taskDetails.buyouts',
    defaultMessage: 'Usages',
  },
  audioFormat: {
    id: 'containers.SupplierTaskPage.taskDetails.audioFormat',
    defaultMessage: 'Audio Format',
  },
  none: {
    id: 'containers.SupplierTaskPage.none',
    defaultMessage: '(none)',
  },
  production: {
    id: 'containers.SupplierTaskPage.production',
    defaultMessage: 'Production',
  },
  registerIncident: {
    id: 'containers.SupplierTaskPage.registerIncident',
    defaultMessage: 'Register incident',
  },
  approveTask: {
    id: 'containers.SupplierTaskPage.approveTask',
    defaultMessage: 'Approve Task',
  },
  denyTask: {
    id: 'containers.SupplierTaskPage.denyTask',
    defaultMessage: 'Deny Task',
  },
  sendMessage: {
    id: 'containers.SupplierTaskPage.sendMessage',
    defaultMessage: 'Send message to coordinator',
  },
  sendMessageWithoutApproving: {
    id: 'containers.SupplierTaskPage.sendMessageWithoutApproving',
    defaultMessage: 'Send message to coordinator without approving or denying task',
  },
  status: {
    id: 'containers.SupplierTaskPage.status',
    defaultMessage: 'Status:',
  },
  details: {
    id: 'containers.SupplierTaskPage.details',
    defaultMessage: 'Details:',
  },
  retake: {
    id: 'containers.SupplierTaskPage.retake',
    defaultMessage: 'Retake:',
  },
  coordinatorMessage: {
    id: 'containers.SupplierTaskPage.coordinatorMessage',
    defaultMessage: 'Message from Coordinator:',
  },
  messageList: {
    id: 'containers.SupplierTaskPage.messageList',
    defaultMessage: 'Messages:',
  },
  filesFromCoordinator: {
    id: 'containers.SupplierTaskPage.filesFromCoordinator',
    defaultMessage: 'Original Files from Coordinator',
  },
  downloadAllFiles: {
    id: 'containers.SupplierTaskPage.downloadAllFiles',
    defaultMessage: 'Download All Files as Zip',
  },
  versionTasks: {
    id: 'containers.SupplierTaskPage.versionTasks',
    defaultMessage: 'Version Tasks',
  },
  conversionGuide: {
    id: 'containers.SupplierTaskPage.conversionGuide',
    defaultMessage: 'for a guide to adjust your file format settings, in your DAW.',
  },
  versioned: {
    id: 'containers.SupplierTaskPage.versionFilesTitle.versioned',
    defaultMessage: 'Version files from PM',
  },
  translated: {
    id: 'containers.SupplierTaskPage.versionFilesTitle.translated',
    defaultMessage: 'Translated files from PM',
  },
  voiceOver: {
    id: 'containers.SupplierTaskPage.versionFilesTitle.voiceOver',
    defaultMessage: 'Voice recordings from PM',
  },
  buyouts: {
    id: 'containers.SupplierTaskPage.buyouts',
    defaultMessage: 'Usages:',
  },
  buyoutsInstructions: {
    id: 'containers.SupplierTaskPage.buyoutsInstructions',
    defaultMessage: 'Please fill in your best price when approving the task',
  },
  voBrief: {
    id: 'containers.SupplierTaskPage.voBrief',
    defaultMessage: 'Brief of Voice Over task: {taskId}',
  },
  usageTerms: {
    id: 'containers.SupplierTaskPage.usageTerms',
    defaultMessage: 'Advertising workflow at VoiceArchive',
  },
  usageTermsValue: {
    id: 'containers.SupplierTaskPage.usageTermsValue',
    defaultMessage: 'Click <a>here</a> to review',
  },
  usageCustomerCancelation: {
    id: 'containers.SupplierTaskPage.usageCustomerCancelation',
    defaultMessage: 'Cancellation policy',
  },
  usageCustomerCancelationValue: {
    id: 'containers.SupplierTaskPage.usageCustomerCancelationValue',
    defaultMessage: 'In the unlikely event that a client cancels the agreed usage within 14 days, a basic effort fee (BSF) will still be compensated',
  },
  wordCount: {
    id: 'containers.SupplierTaskPage.wordCount',
    defaultMessage: 'Word count',
  },
  retakeTitle: {
    id: 'containers.SupplierTaskPage.retakeTitle',
    defaultMessage: "Be aware, there is a retake on this job.",
  },
  retakeSubTitle: {
    id: 'containers.SupplierTaskPage.retakeSubTitle',
    defaultMessage: "Are you looking for the retake job to upload your work? Click <a>here</a> to view the task.",
  },
  retakeSubTitleMultiple: {
    id: 'containers.SupplierTaskPage.retakeSubTitleMultiple',
    defaultMessage: "Are you looking for the retake job to upload your work? Here are the links to the retakes: {links}.",
  },
  onwards: {
    id: 'containers.SupplierTaskPage.onwards',
    defaultMessage: "onwards",
  },
  memoriesTitle: {
    id: 'containers.SupplierTaskPage.memoriesTitle',
    defaultMessage: "Pronunciations",
  },
  uploadedFiles: {
    id: 'containers.SupplierTaskPage.uploadedFiles',
    defaultMessage: "Your uploaded files",
  },
})
